module.exports = __webpack_public_path__ + "logo.jpg?2151783fa7e073234c2561607bf20159";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.jpg
// module id = 496
// module chunks = 0